import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  infoTitle: {
    marginTop: "0px"
  },
  eStatementsFormControl: {
    marginTop: "15px",
    marginBottom: "0px"
  },
  mailStatementsFormControl: {
    marginTop: "0px"
  },
  divider: {
    marginTop: "17px"
  },
  rootGrid: {
    padding: "20px 0px"
  },
  continueBtn: {
    float: "right"
  }
});
